import $ from 'jquery/dist/jquery.min'

export default class PropertiesMobileTabs {

  constructor() {
    this.$tabBodies;
    this.$mobileTab = $('.mobile-tab')
    this.$initialActiveTab;
    this.initTabs();
    this.currentWidth = $(window).width()
  }

  initTabs() {
    this.$tabBodies = $('.map, .filters__container, .sorting__wrapper, .property-archive')
  }

  initMobileTabs() {
    const tabs = `
      <div class="mobile-tabs">
        <button class="mobile-tab js-mobile-tab" data-tab="map-view">
          <div class="mobile-tab__content">
            <img loading="lazy" class="mobile-tab__icon mobile-tab__icon--active" src="/static/images/tab-icon--map-view--active.svg">
            <img loading="lazy" class="mobile-tab__icon mobile-tab__icon--inactive" src="/static/images/tab-icon--map-view--inactive.svg">
            <span>Map View</span>
          </div>
        </button>
        <button class="mobile-tab js-mobile-tab" data-tab="list-view">
          <div class="mobile-tab__content">
            <img loading="lazy" class="mobile-tab__icon mobile-tab__icon--active" src="/static/images/tab-icon--list-view--active.svg">
            <img loading="lazy" class="mobile-tab__icon mobile-tab__icon--inactive" src="/static/images/tab-icon--list-view--inactive.svg">
            <span>List View</span>
          </div>
        </button>
        <button class="mobile-tab js-mobile-tab" data-tab="filters">
          <div class="mobile-tab__content">
            <img loading="lazy" class="mobile-tab__icon mobile-tab__icon--active" src="/static/images/tab-icon--filters--active.svg">
            <img loading="lazy" class="mobile-tab__icon mobile-tab__icon--inactive" src="/static/images/tab-icon--filters--inactive.svg">
            <span>Filters</span>
          </div>
        </button>
      </div>
    `;

    $('#app').prepend(tabs);
    this.$tabBodies.addClass('mobile-tab__body');
    this.$initialActiveTab = $('.mobile-tab[data-tab=map-view]');
    this.doTabAction(this.$initialActiveTab);
  }

  listenForTabChange() {
    const app = this;
    this.$mobileTab = $('.js-mobile-tab');
    this.$mobileTab.click(function(e){
      app.doTabAction($(this))
    });
  }

  listenForWindowChange() {
    const app = this;
    $(window).resize(function(e){
      const windowWidth = $(window).width()
      if (windowWidth > 600) {
        app.$tabBodies.show();
      }
      else {
        if (windowWidth != app.currentWidth) {
          app.doTabAction(app.$initialActiveTab);
        }
      }
      app.currentWidth = windowWidth
    });
  }

  doTabAction(input) {
    if ($(window).width() > 600) {
      this.$tabBodies.show();
      return;
    }
    const tab = input.attr('data-tab');
    this.$mobileTab.removeClass('mobile-tab--active');
    $('.mobile-tab').filter('[data-tab='+tab+']').addClass('mobile-tab--active');
    this.$tabBodies.hide();
    this.$tabBodies.filter('[data-tab-body='+tab+']').show();
  }
}



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/properties-app/PropertiesMobileTabs.jsx